module.exports = __webpack_public_path__ + "static/img/2_huoma1@2x.b0b9fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_huoma1@2x.png
// module id = IufO
// module chunks = 8